/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
// import Modal from "react-responsive-modal";

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
import Barcode from 'react-barcode';
//import PerfectScrollbar from 'react-perfect-scrollbar';

import Slider from 'react-slick';
import moment from 'moment';

class CardList extends PureComponent {
  state = {
    slideIndex: 0,
    slidePlay: true,
    remainCash: 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;

    this._getCardList();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getCardList = async () => {
    const { loginId, pkg } = this.props;

    if (
      loginId === null ||
      loginId === undefined ||
      loginId === '' ||
      pkg === null ||
      pkg === undefined ||
      pkg === ''
    ) {
    } else {
      const result = await this._getCardListApi();
      if (result) {
        const intReturn = result.data[0].intReturn;

        const cardList = result.data[0].listData;
        const remainCash = result.data[0].cash;
        //console.log(cardList)
        if (intReturn === 0) {
          if (this._isMounted) {
            this.setState({
              cardList,
              remainCash,
              winReg: false,
            });
          }
        } else {
          this.setState({
            remainCash,
          });
        }
      }
    }
  };

  _getCardListApi = () => {
    const { apiUrl, loginId, pkg, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    return axios
      .post(
        apiUrl + '/cardList_pkg',
        {
          params: {
            userid: loginId,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (part) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (part === 0) {
        this._getCardList();
      } else {
        this._onCardStop(part);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onReg = () => {
    const { setCardListShow, setCardRegShow } = this.props;

    setCardListShow(false);
    setCardRegShow(true);
  };
  _onCardRegHide = () => {
    const { setCardListShow } = this.props;
    setCardListShow(false);
  };
  _cardStop = (cardNumber) => {
    const { setCardListShow } = this.props;
    setCardListShow(false);
    confirmAlert({
      title: '포인트카드 정지',
      message:
        '해당 카드를 정지 하시겠습니까? 정지된 카드는 온/오프라인에서 사용 할 수 없으며, 정지 해지가 불가합니다.',
      buttons: [
        {
          label: '카드 정지하기',
          onClick: () => {
            this._onCardStop(cardNumber);
          },
        },

        {
          label: '취소',
          onClick: () => {
            setCardListShow(true);
          },
        },
      ],
    });
  };
  _onCardStop = async (cardNumber) => {
    const { setCardListShow, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._onCardStopApi(cardNumber);
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('정상적으로 카드가 정지 처리 되었습니다.');
          setCardListShow(true);
        } else {
          toast.error(
            '카드 정지 처리중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'
          );
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _onCardStopApi = (cardNumber) => {
    const { apiUrl, loginId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/cardStop',
        {
          params: {
            userid: loginId,
            cardNumber: cardNumber,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(cardNumber);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _renderItem = () => {
    const { cardList, slideIndex } = this.state;

    const list = cardList.map((item, index) => {
      return (
        <div className="cashcard_item" key={index}>
          <ul className="card_txt">
            <li className="num">{slideIndex + 1}</li>
            <li className="tit">
              <p className="name">
                {item.cardName === '' ||
                item.cardName === null ||
                item.cardName === undefined
                  ? '포인트카드'
                  : item.cardName}
              </p>
              <p className="date">
                {moment(item.regDate).format('YYYY.MM.DD')} 등록
              </p>
            </li>
            <li className="page">
              <p>
                <span>{slideIndex + 1}</span>/{cardList.length}
              </p>
            </li>
          </ul>
          <ul className="cashcard">
            <li className="card_img">
              <img src={item.cardImg} />
            </li>
            <li className="card_barcode">
              <Barcode
                value={item.cardNumber}
                displayValue={false}
                height={100}
                format="CODE128"
                fontSize={9}
                margin={2}
                textMargin={1}
                width={2}
              />
            </li>
            <li className="barcode">
              {item.cardNumber.substr(0, 4)}-{item.cardNumber.substr(4, 4)}-
              {item.cardNumber.substr(8, 4)}-{item.cardNumber.substr(12, 3)}
            </li>
          </ul>
        </div>
      );
    });

    return list;
  };
  _goCash = () => {
    const { history, setCardListShow } = this.props;

    setCardListShow(false);

    history.push('/ticket');
  };
  render() {
    const { cardList, remainCash } = this.state;
    const { imgUrl } = this.props;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      //speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      //centerMode: true,

      //variableWidth: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    };
    return (
      <Fragment>
        <div className="cashcard_top">
          <h2>나의 포인트카드</h2>
          <p className="total">
            총 <b>{this._CommaFormatted(remainCash)}</b>포인트
          </p>
          <button type="button" className="btn_cash" onClick={this._goCash}>
            포인트충전
          </button>
        </div>
        <div className="cashcard_con">
          <a
            onClick={this._onPrev}
            className="arrw_prev"
            style={{ cursor: 'pointer' }}
          >
            이전
          </a>
          <a
            onClick={this._onNext}
            className="arrw_next"
            style={{ cursor: 'pointer' }}
          >
            다음
          </a>

          <Slider ref={(ref) => (this.slider = ref)} {...settings}>
            {cardList ? (
              this._renderItem()
            ) : (
              <div className="cashcard_item">
                <ul className="card_txt">
                  <li className="num">1</li>
                  <li className="tit">
                    <p className="name">보유카드 카드없음</p>
                    <p className="date"></p>
                  </li>
                  <li className="page">
                    <p>
                      <span>0</span>/0
                    </p>
                  </li>
                </ul>
                <ul className="cashcard">
                  <li className="card_img">
                    <img src={imgUrl + '/img/cashcard/cashcard.png'} />
                  </li>
                  <li className="card_barcode">
                    <img src={imgUrl + '/img/cashcard/barcode2.png'} />
                  </li>
                  <li className="barcode">XXXX-XXXX-XXXX-XXX</li>
                </ul>
              </div>
            )}
          </Slider>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(CardList)));
